import { isEqual, uniqBy } from 'lodash';

/* function to calculate resulted columns from source file groupBy columns list */
const getSrcColsFromList = (updatedConfigData, srcGrpByCols, colList, index) => {
    let srcCol = '';
    let newValue = {};
    if (colList.length > 1) {
        updatedConfigData[0].selectedColumns.forEach(c => {
            if (colList.includes(c.column)) {
                srcCol = `${c.column}_${updatedConfigData[0].id.split('dndnode_')[1]}`;
                newValue = {
                    ...c,
                    column: `${c.column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
                    displayName: `${c.column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
                };
            } else {
                srcCol = `${srcGrpByCols[index].column}_${updatedConfigData[0].id.split('dndnode_')[1]}`;
                newValue = {
                    ...srcGrpByCols[index],
                    column: `${srcGrpByCols[index].column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
                    displayName: `${srcGrpByCols[index].column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
                };
            }
        });
    } else {
        srcCol = `${srcGrpByCols[index].column}_${updatedConfigData[0].id.split('dndnode_')[1]}`;
        newValue = {
            ...srcGrpByCols[index],
            column: `${srcGrpByCols[index].column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
            displayName: `${srcGrpByCols[index].column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
        };
    }
    return { srcCol, newValue };
};

/* function to calculate columns from source file columnss selected */
const getSrcCols = (updatedConfigData, colList) => {
    let srcCol = '';
    let newValue = {};
    updatedConfigData[0].selectedColumns.forEach(sc => {
        if (colList.includes(sc.column)) {
            srcCol = `${sc.column}_${updatedConfigData[0].id.split('dndnode_')[1]}`;
            newValue = {
                ...sc,
                column: `${sc.column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
                displayName: `${sc.column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
            };
        }
    });
    return { srcCol, newValue };
};

/* function to calculate resulted columns from source file groupBy columns selected */
const getResultColumnsFromSrcGrpBy = (updatedConfigData, srcGrpByCols) => {
    const result = [];
    if (srcGrpByCols.length > 1) {
        const srcCols = [];
        srcGrpByCols.forEach((sg, index) => {
            const colList = sg.column.split(',');
            const { srcCol, newValue } = getSrcColsFromList(updatedConfigData, srcGrpByCols, colList, index);
            srcCols.push(srcCol);
            result.push(newValue);
        });
        const groupByCols = {
            ...updatedConfigData[0].selectedColumns[0],
            displayName: 'Alias1',
            aliasName: 'Alias1',
            column: srcCols.join(','),
        };
        result.push(groupByCols);
    } else if (srcGrpByCols.length > 0) {
        if (srcGrpByCols[0].aliasName) {
            const colList = srcGrpByCols[0].column.split(',');
            const srcCols = [];
            const { srcCol, newValue } = getSrcCols(updatedConfigData, colList);
            srcCols.push(srcCol);
            result.push(newValue);
            result.push({
                ...srcGrpByCols[0],
                displayName: 'Alias1',
                aliasName: 'Alias1',
                column: srcCols.join(','),
            });
        } else {
            result.push({
                ...srcGrpByCols[0],
                column: `${srcGrpByCols[0].column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
                displayName: `${srcGrpByCols[0].column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
                showInGroupBy: true,
            });
        }
    }
    return result;
};

/* function to calculate resulted columns from target file groupBy columns list */
const getTrgtColsFromList = (updatedConfigData, trgtGrpByCols, colList, index) => {
    let trgtCol = '';
    let newValue = {};
    if (colList.length > 1) {
        updatedConfigData[1].selectedColumns.forEach(c => {
            if (colList.includes(c.column)) {
                trgtCol = `${c.column}_${updatedConfigData[1].id.split('dndnode_')[1]}`;
                newValue = {
                    ...c,
                    column: `${c.column}_${updatedConfigData[1].id.split('dndnode_')[1]}`,
                    displayName: `${c.column}_${updatedConfigData[1].id.split('dndnode_')[1]}`,
                };
            }
        });
    } else {
        trgtCol = `${trgtGrpByCols[index].column}_${updatedConfigData[1].id.split('dndnode_')[1]}`;
        newValue = {
            ...trgtGrpByCols[index],
            column: `${trgtGrpByCols[index].column}_${updatedConfigData[1].id.split('dndnode_')[1]}`,
            displayName: `${trgtGrpByCols[index].column}_${updatedConfigData[1].id.split('dndnode_')[1]}`,
        };
    }
    return { trgtCol, newValue };
};

/* function to calculate columns from target file columns selected */
const getTrgtCols = (updatedConfigData, colList) => {
    let trgtCol = '';
    let newValue = {};
    updatedConfigData[1].selectedColumns.forEach(sc => {
        if (colList.includes(sc.column)) {
            trgtCol = `${sc.column}_${updatedConfigData[1].id.split('dndnode_')[1]}`;
            newValue = {
                ...sc,
                column: `${sc.column}_${updatedConfigData[1].id.split('dndnode_')[1]}`,
                displayName: `${sc.column}_${updatedConfigData[1].id.split('dndnode_')[1]}`,
            };
        }
        return sc;
    });
    return { trgtCol, newValue };
};

/* function to calculate resulted columns from target file groupBy columns selected */
const getResultColumnsFromTrgtGrpBy = (updatedConfigData, trgtGrpByCols) => {
    const result = [];
    if (trgtGrpByCols.length > 1) {
        const trgtCols = [];
        trgtGrpByCols.forEach((tg, index) => {
            const colList = tg.column.split(',');
            const { trgtCol, newValue } = getTrgtColsFromList(updatedConfigData, trgtGrpByCols, colList, index);
            trgtCols.push(trgtCol);
            result.push(newValue);
        });
        const groupByCols = {
            ...updatedConfigData[1].selectedColumns[0],
            displayName: 'Alias2',
            aliasName: 'Alias2',
            column: trgtCols.join(','),
        };
        result.push(groupByCols);
    } else if (trgtGrpByCols.length > 0) {
        if (trgtGrpByCols[0].aliasName) {
            const trgtCols = [];
            const colList = trgtGrpByCols[0].column.split(',');
            const { trgtCol, newValue } = getTrgtCols(updatedConfigData, colList);
            trgtCols.push(trgtCol);
            result.push(newValue);
            result.push({
                ...trgtGrpByCols[0],
                displayName: 'Alias2',
                aliasName: 'Alias2',
                column: trgtCols.join(','),
            });
        } else {
            result.push({
                ...trgtGrpByCols[0],
                column: `${trgtGrpByCols[0].column}_${updatedConfigData[1].id.split('dndnode_')[1]}`,
                displayName: `${trgtGrpByCols[0].column}_${updatedConfigData[1].id.split('dndnode_')[1]}`,
                showInGroupBy: true,
            });
        }
    }
    return result;
};

/* function to calculate resulted columns after the Sum/Max/Min operation */
const calculateResultColumnsForSumMinMax = updatedConfigData => {
    const srcCol = updatedConfigData[0].selectedColumns.filter(item => item.isSourceColumn);
    const trgtCol = updatedConfigData[1].selectedColumns.filter(item => item.isTargetColumn);
    const srcGroupByCols = updatedConfigData[0].selectedColumns.filter(item => item.isSourceGroupBy);
    const trgtGroupByCols = updatedConfigData[1].selectedColumns.filter(item => item.isTargetGroupBy);
    let result = [];
    result.push({
        ...srcCol[0],
        column: `${srcCol[0].column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
        displayName: `${srcCol[0].column}_${updatedConfigData[0].id.split('dndnode_')[1]}`,
        showInGroupBy: true,
    });
    result.push({
        ...trgtCol[0],
        column: `${trgtCol[0].column}_${updatedConfigData[1].id.split('dndnode_')[1]}`,
        displayName: `${trgtCol[0].column}_${updatedConfigData[1].id.split('dndnode_')[1]}`,
        showInGroupBy: true,
    });
    result = result.concat(getResultColumnsFromSrcGrpBy(updatedConfigData, srcGroupByCols));
    result = result.concat(getResultColumnsFromTrgtGrpBy(updatedConfigData, trgtGroupByCols));
    return result;
};

const calculateResultColumnsForAppend = updatedConfigData => {
    let resultSelectedColumns = updatedConfigData[0].selectedColumns
        .filter(item => item.isChecked)
        .concat(updatedConfigData[1].selectedColumns
            .filter(item => !item.isConcateCheck));
    resultSelectedColumns = uniqBy(resultSelectedColumns, 'column');
    resultSelectedColumns = resultSelectedColumns.map(rc => ({
        ...rc,
        isConcateCheck: false,
    }));
    return resultSelectedColumns;
};

/* functions to get list of target file columns */
const getJoinTargetColumns = (updatedConfigData, sourceCols) => {
    const cols = [];
    updatedConfigData[1].selectedColumns.map(sc => {
        const found = sourceCols.find(item => item.column === sc.column && item.isJoin);
        if (!found) {
            cols.push({ ...sc });
        }
        return sc;
    });
    return cols;
};

/* functions to get list of updated source file columns to be selected in join query */
const getUpdatedSourceColumnsForJoin = (updatedConfigData, srcCols, targetCols, srcFileName) => srcCols.map(src => {
    const found = targetCols.find(item => item.column === src.column);
    if (found) {
        return {
            ...src,
            column: `${src.column}_${srcFileName}`,
            fileName: `${updatedConfigData[0].fileName}`,
        };
    }
    return src;
});

/* functions to get list of updated target file columns to be selected in join query */
const getUpdatedTargetColumnsForJoin = (updatedConfigData, srcColumns, targetColumns, trgtFileName) => targetColumns.map(trgt => {
    const found = srcColumns.find(item => item.column === trgt.column);
    if (found) {
        return {
            ...trgt,
            column: `${trgt.column}_${trgtFileName}`,
            fileName: `${updatedConfigData[1].fileName}`,
        };
    }
    return trgt;
});

const calculateResultColumnsForJoin = (updatedConfigData, sourceFileName, targetFileName) => {
    const srcColumns = updatedConfigData[0].selectedColumns.filter(item => item.isChecked);
    // get target file columns
    const trgtColumns = getJoinTargetColumns(updatedConfigData, srcColumns);
    // get updated list of source file columns
    const updatedSrcCols = getUpdatedSourceColumnsForJoin(updatedConfigData, srcColumns, trgtColumns, sourceFileName);
    // get updated list of target file columns
    const updatedTargetCols = getUpdatedTargetColumnsForJoin(updatedConfigData, srcColumns, trgtColumns, targetFileName);
    return [].concat(updatedSrcCols).concat(updatedTargetCols);
};

/* functions to get filters added in source file */
const getSourceFilter = updatedConfigData => {
    if (!updatedConfigData[0].fileName.includes('result')) {
        return updatedConfigData[0].selectedColumns.map((c, index) => (
            c.operation !== 'date_filter' ? {
                id: index,
                operation: c.operation,
                transformation: c.transformation,
                sourceColumn: c.column,
            } : {
                id: index,
                operation: c.operation,
                startDate: c.start_date,
                endDate: c.end_date,
                sourceColumn: c.column,
            }
        )).filter(item => item.operation !== '');
    }
    return [];
};

/* functions to get filters added in target file */
const getTargetFilter = updatedConfigData => {
    if (!updatedConfigData[1].fileName.includes('result')) {
        return updatedConfigData[1].selectedColumns.map((sc, index) => (
            sc.operation !== 'date_filter' ? {
                id: index,
                operation: sc.operation,
                transformation: sc.transformation,
                sourceColumn: sc.column,
            } : {
                id: index,
                operation: sc.operation,
                startDate: sc.start_date,
                endDate: sc.end_date,
                sourceColumn: sc.column,
            }
        )).filter(item => item.operation !== '');
    }
    return [];
};

const getSumMinMaxConfig = (updatedConfigData, sourceGroupBy, targetGroupBy) => {
    const sourceColumns = updatedConfigData[0].selectedColumns.filter(item => item.isSourceColumn).map(c => c.column).filter((x, i, a) => a.indexOf(x) === i);
    const targetColumns = updatedConfigData[1].selectedColumns.filter(item => item.isTargetColumn).map(c => c.column);
    const resultSelectedColumns = calculateResultColumnsForSumMinMax(updatedConfigData);
    const updatedsrcGrpBy = sourceGroupBy.filter((x, i, a) => a.indexOf(x) === i);
    return {
        sourceColumns,
        targetColumns,
        targetGroupBy,
        sourceGroupBy: updatedsrcGrpBy,
        resultSelectedColumns,
    };
};

const getAppendConfig = updatedConfigData => {
    const sourceColumns = updatedConfigData[0].selectedColumns.filter(item => item.isConcateCheck).map(sc => (sc.column));
    const targetColumns = updatedConfigData[1].selectedColumns.filter(item => item.isConcateCheck).map(tc => (tc.column));
    const resultSelectedColumns = calculateResultColumnsForAppend(updatedConfigData);
    return {
        sourceColumns,
        targetColumns,
        resultSelectedColumns,
    };
};

const getJoinConfig = (updatedConfigData, sourceFileName, targetFileName) => {
    const sourceColumns = updatedConfigData[0].selectedColumns.filter(item => item.isJoin).map(sc => (sc.column));
    const targetColumns = updatedConfigData[1].selectedColumns.filter(item => item.isJoin).map(tc => (tc.column));
    const resultSelectedColumns = calculateResultColumnsForJoin(updatedConfigData, sourceFileName, targetFileName);
    return {
        sourceColumns,
        targetColumns,
        resultSelectedColumns,
    };
};

const getBasicConfig = (updatedConfigData, operation) => {
    const sourceId = updatedConfigData[0].id;
    const targetId = updatedConfigData[1].id;
    const sourceFileId = updatedConfigData[0]?.fileId;
    const sourceFileName = updatedConfigData[0].fileName;
    const isSourceSubProject = updatedConfigData[0].isSubProject;
    const sourceSubProjectId = isSourceSubProject ? updatedConfigData[0].data.projectId : '';
    const sourceSelectedColumns = updatedConfigData[0].selectedColumns.filter(item => item.isChecked).map(sc => (sc.column)).filter((x, i, a) => a.indexOf(x) === i);
    const targetFileId = updatedConfigData[1]?.fileId;
    const targetFileName = updatedConfigData[1].fileName;
    const isTargetSubProject = updatedConfigData[1].isSubProject;
    const targetSubProjectId = isTargetSubProject ? updatedConfigData[1].data.projectId : '';
    const targetSelectedColumns = updatedConfigData[1].selectedColumns.filter(item => item.isChecked).map(sc => (sc.column));
    const sourceFilter = getSourceFilter(updatedConfigData);
    const targetFilter = getTargetFilter(updatedConfigData);

    return {
        sourceId,
        targetId,
        sourceFileId,
        sourceFileName,
        isSourceSubProject,
        sourceSubProjectId,
        sourceSelectedColumns,
        targetFileId,
        targetFileName,
        isTargetSubProject,
        targetSubProjectId,
        targetSelectedColumns,
        sourceFilter,
        targetFilter,
        updatedConfigData,
        operation,
    };
};

export const getSourceGroupByFromOldConfig = (prevConfig, oldConfigData) => {
    const grpByCols = [];
    prevConfig.sourceGroupBy.map(item => {
        const columnFound = oldConfigData[0].selectedColumns.find(({ column }) => item === column);
        if (columnFound) {
            grpByCols.push(item);
            return item;
        }
        return item;
    });
    return grpByCols;
};

export const getTargetGroupByFromOldConfig = (prevConfig, oldConfigData) => {
    const grpByCols = [];
    prevConfig.targetGroupBy.map(item => {
        const columnFound = oldConfigData[1].selectedColumns.find(({ column }) => item === column);
        if (columnFound) {
            grpByCols.push(item);
            return item;
        }
        return item;
    });
    return grpByCols;
};

export const getUpdatedSrcGroupByList = configData => configData[0].selectedColumns.filter(sc => (
    sc.showInGroupBy || sc.aliasName
));

export const getUpdatedTrgtGroupByList = configData => configData[1].selectedColumns.filter(sc => (
    sc.showInGroupBy || sc.aliasName
));

export const getUpdatedSourceColumn = (prevSrcCol, newSrcCol) => {
    if (prevSrcCol !== newSrcCol) {
        return newSrcCol;
    }
    return prevSrcCol;
};

export const getUpdatedTargetColumn = (prevTrgtCol, newTrgtCol) => {
    if (prevTrgtCol !== newTrgtCol) {
        return newTrgtCol;
    }
    return prevTrgtCol;
};

export const getUpdatedSrcGrpByCols = (prevSrcGrpBy, newSrcGrpBy) => {
    if (!isEqual(prevSrcGrpBy, newSrcGrpBy)) {
        return prevSrcGrpBy;
    }
    return newSrcGrpBy;
};

export const getUpdatedTrgtGrpByCols = (prevTrgtGrpBy, newTrgtGrpBy) => {
    if (!isEqual(prevTrgtGrpBy, newTrgtGrpBy)) {
        return prevTrgtGrpBy;
    }
    return newTrgtGrpBy;
};

export const getUpdatedSrcRoundUp = (prevSrcRoundUp, newSrcRoundUp) => {
    if (prevSrcRoundUp !== newSrcRoundUp) {
        return newSrcRoundUp;
    }
    return prevSrcRoundUp;
};

export const getUpdatedTrgtRoundUp = (prevTrgtRoundUp, newTrgtRoundUp) => {
    if (prevTrgtRoundUp !== newTrgtRoundUp) {
        return newTrgtRoundUp;
    }
    return prevTrgtRoundUp;
};

export const shouldShowSrcGrpByList = (srcGroupByList, updatedConfigData) => {
    if (srcGroupByList.length === 0 && updatedConfigData && updatedConfigData[0] && updatedConfigData[0].selectedColumns) {
        return true;
    }
    return false;
};

export const shouldShowTrgtGrpByList = (trgtGroupByList, updatedConfigData) => {
    if (trgtGroupByList.length === 0 && updatedConfigData && updatedConfigData[1] && updatedConfigData[1].selectedColumns) {
        return true;
    }
    return false;
};

export const isValidConfig = configData => {
    const error = { message: '' };
    let count = 0;
    configData.forEach(c => {
        if (c.selectedColumns && c.selectedColumns.length === 0) {
            count += 1;
        }
    });
    if (count > 0) {
        error.message = 'Please select atleast one column in source and target file!';
    }
    return error;
};

export const buildConfig = (updatedConfigData, operation, sourceGroupBy, targetGroupBy) => {
    const basicConfig = getBasicConfig(updatedConfigData, operation);
    let configRelatedToRecon;
    if (operation === 'Sum' || operation === 'Min' || operation === 'Max') {
        configRelatedToRecon = getSumMinMaxConfig(updatedConfigData, sourceGroupBy, targetGroupBy);
    } else if (operation === 'Append') {
        configRelatedToRecon = getAppendConfig(updatedConfigData);
    } else {
        configRelatedToRecon = getJoinConfig(updatedConfigData, basicConfig.sourceFileName, basicConfig.targetFileName);
    }
    return {
        ...basicConfig,
        ...configRelatedToRecon,
    };
};
